import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MainserviceService } from '../service/mainservice.service';
import { EnrollCourseMaster } from '../model/EnrollCourseMaster.model';
import { StudentLectureMaster } from '../model/StudentLectureMaster.model';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import Player from '@vimeo/player';
import { StudentLectureMcqMaster } from '../model/StudentLectureMcqMaster.model';
import { ContentMaster } from '../model/ContentMaster.model';
import { StudentLectureContentMaster } from '../model/StudentLectureContentMaster.model';
import Swal from 'sweetalert2'
import { AskAQuery } from '../model/AskAQuery.model';
import { User } from '../model/User.model';
import { AuthService } from '../service/auth.service';
@Component({
  selector: 'app-student-learning',
  templateUrl: './student-learning.component.html',
  styleUrls: ['./student-learning.component.scss']
})
export class StudentLearningComponent implements OnInit {
  enrollCourseMaster: EnrollCourseMaster = new EnrollCourseMaster();
  studentLectureMaster: StudentLectureMaster = new StudentLectureMaster();
  studentLectureMasterSession: StudentLectureMaster = new StudentLectureMaster();
  player;
  studentLectureMcqMaster: StudentLectureMcqMaster = new StudentLectureMcqMaster();
  selectedMcq: StudentLectureMcqMaster = new StudentLectureMcqMaster();
  index: number = 0;
  studentLectureContentMaster: StudentLectureContentMaster = new StudentLectureContentMaster();
  selectedStudentLectureContentMaster: StudentLectureContentMaster = new StudentLectureContentMaster();
  openmcqdialog: boolean = false;
  characters: any[] = ["A", "B", "C", "D", "E", "F", "G", "H"];
  askquery: AskAQuery = new AskAQuery();
  openaskquerydialog: boolean = false;
  userSession: User = new User();
  displayNotPaidMessage: string;
  diplayNoLectureMessage: string;
  defaultStudentLectureMaster: StudentLectureMaster = new StudentLectureMaster();
  studentLectureContentList: StudentLectureContentMaster[] = [];

  constructor(private mainService: MainserviceService, public activater: ActivatedRoute, private authService: AuthService, public el: ElementRef, private router: Router) {

  }

  ngOnInit() {
    this.getStudentLectureMaster();

    this.initPlayer();
    this.playVideo();
    // this.userSession = this.authService.getUserSession();
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);

    });

  }

  getStudentLectureMaster() {


    this.studentLectureMasterSession = this.mainService.getstudentLectureMasterSession();
    if (this.studentLectureMasterSession.studentLectureMasterId != null) {
      this.studentLectureMaster.studentLectureMasterId = this.studentLectureMasterSession.studentLectureMasterId;
      this.mainService.getStudentLecture(this.studentLectureMaster).subscribe(data => {
        this.studentLectureMaster = data;

        this.selectedStudentLectureContent(this.studentLectureMaster.studentLectureContentVideosList[0]);
      });
    }
    if (this.studentLectureMasterSession.errorMessage == "NO-PAID") {
      this.displayNotPaidMessage = "Current Month not Paid";
    }
    if (this.studentLectureMasterSession.errorMessage == "NO-LECTURE") {
      this.diplayNoLectureMessage = "No Lecture For Today";
    }
    // if(this.studentLectureMasterSession.err)


  }


  selectedStudentLectureContent(studentLectureContentMaster: StudentLectureContentMaster) {
    setTimeout(() => {

      this.setVideoCurrentTime(this.selectedStudentLectureContentMaster.watchedTime);
      this.updateLastWatchTime();

    }, 3000);

  }

  startMcq() {
    this.openmcqdialog = true;
  }



  nextMcq() {

    if (this.index < this.studentLectureMaster.studentLectureMcqMasterList.length - 1) {
      this.index = this.index + 1;

    }
  }
  prevMcq() {
    if (this.index <= this.studentLectureMaster.studentLectureMcqMasterList.length - 1) {
      this.index = this.index - 1;
    }
  }
  // vimeo player functions
  private initPlayer() {
    this.player = new Player('video_iframe', {});
  }
  private destroyPlayer() {
    this.player.destroy().then(function () {
      // the player was destroyed
    }).catch(function (error) {
      // an error occurred
    });
  }

  setVideo(videoId: any) {
    // this.destroyPlayer();
    // this.initPlayer();

    this.player.loadVideo(videoId).then(function (id) {

    });

  }

  playVideo() {
    setTimeout(() => {
      this.player.play().then(function () {

      });
    }, 5000);
  }


  saveMcq() {

    let studentLectureMcqMasterTemp: StudentLectureMcqMaster = new StudentLectureMcqMaster();
    studentLectureMcqMasterTemp.studentLectureMCQMasterId = this.studentLectureMaster.studentLectureMcqMasterList[this.index].studentLectureMCQMasterId;
    studentLectureMcqMasterTemp.answerContentMaster = this.studentLectureMaster.studentLectureMcqMasterList[this.index].answerContentMaster;
    this.mainService.saveStudentLectureMCQAnswer(studentLectureMcqMasterTemp).subscribe(data => {
      Swal.fire({
        title: 'Success',
        text: 'MCQ Saved Successfully!',
        icon: 'success',
        showCancelButton: true,
        showConfirmButton: true,
      })

    });
  }
  askQuery() {
    this.studentLectureMasterSession = this.mainService.getstudentLectureMasterSession();
    let studentLectureMasterTemp: StudentLectureMaster = new StudentLectureMaster();
    studentLectureMasterTemp.studentLectureMasterId = this.studentLectureMasterSession.studentLectureMasterId
    this.askquery.studentLectureMaster = studentLectureMasterTemp;

    this.askquery.createdBy = this.userSession;
    this.mainService.askAQuery(this.askquery).subscribe(data => {
      this.askquery = data;
      this.studentLectureMaster.askAQueryList.push(this.askquery);
      this.askquery = new AskAQuery();

    })
  }
  letsChat() {
    this.openaskquerydialog = true;
  }
  getVideoCurrentTime(studentLectureContentMaster: StudentLectureContentMaster) {

    this.player.getCurrentTime().then(function (seconds) {
      studentLectureContentMaster.watchedTime = seconds;
    });

  }

  setVideoCurrentTime(currentTime: any) {
    if (currentTime != null) {
      this.player.setCurrentTime(currentTime).then(function (id) {
      });
    }
  }
  updateLastWatchTime() {

    setTimeout(() => {

      this.getVideoCurrentTime(this.selectedStudentLectureContentMaster);

      this.updateLastWatchTime();
      this.mainService.updateLastWatchedTime(this.selectedStudentLectureContentMaster).subscribe(data => {

      });



    }, 5000);


  }
  getupdatedLastWatchedTime() {
    let studentLectureContentMasterTemp: StudentLectureContentMaster = new StudentLectureContentMaster();
    studentLectureContentMasterTemp.studentLectureContentMasterId = this.studentLectureMaster.studentLectureContentVideosList[0].studentLectureContentMasterId;
    this.mainService.updateLastWatchedTime(studentLectureContentMasterTemp).subscribe(data => {
      this.studentLectureContentMaster = data;

    });
  }

}
